import Cookies from 'universal-cookie';

const fetcher = async (url: string, options?: RequestInit) => {
    const cookies = new Cookies();

    return fetch(url, {
        ...options,
        method: options?.method || 'GET',
        mode: 'cors', // no-cors, *cors, same-origin
        credentials: options?.credentials || 'include', // *include, same-origin, omitredirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // *no-referrer, client
        headers: {
            ...(options?.headers || {}),
            'Content-Type': 'application/json',
            'X-Research-Session-Token': cookies.get('sessionToken'),
        },
    }).then(res => res.json());
};

export default fetcher;
